export default __webpack_public_path__ + "static/media/sounds/daze_ready_click_ok_alyx.mp3";